import { computed, defineComponent, ref, watch } from "vue";

export default defineComponent({

    props: [ "src", "default", "crossorigin", "alt" ],

    setup(props) {
        const selected = ref(props.src);
        const crossorigin = computed(() => {
            return props.crossorigin !== undefined
                ? props.crossorigin
                : "anonymous";
        });

        function onError() {
            selected.value = props.default;
        }

        watch(
            () => (props.src),
            () => (selected.value = props.src)
        );

        return () => (
            <img
                src={selected.value}
                onError={onError}
                loading="lazy"
                alt={props.alt}
                crossorigin={crossorigin.value} />
        );
    },
});
